export function parseSpreadsheetIdFromUrl(spreadsheetUrl: string): string {
  return (/\/spreadsheets\/d\/([a-zA-Z0-9-_]+)/.exec(spreadsheetUrl) || ['', ''])[1] || '';
}
